// extracted by mini-css-extract-plugin
export default {"table-root":"SamEntityTable_table-root__w5wDd","table-skeleton-root":"SamEntityTable_table-skeleton-root__JIulV","group":"SamEntityTable_group__8arCP"};